import NetworkStateContext from "contexts/NetworkStateContext";
import WorkOrderSearchContext from "contexts/WorkOrderSearchContext";
import useRefetchWorkOrders from "hooks/apollo/workOrder/useRefetchWorkOrders";
import { useNotificationState } from "hooks/state";
import { useContext } from "react";
import GqlError from "utils/GqlError";
import useFetchSchedulerData from "../useFetchSchedulerData";

export default function useRefetchSchedule() {
  const {
    state: {
      filters: { filterByScheduleView },
    },
  } = useContext(WorkOrderSearchContext);
  const { refetch: refetchWorkOrders } = useRefetchWorkOrders();
  const { refetch: refetchSchedulerData } = useFetchSchedulerData();
  const { trackLoadingState } = useContext(NetworkStateContext);
  const { setNotification } = useNotificationState();

  return ({ dataTimeRange, visibleTimeRange }) =>
    trackLoadingState("GET_BLOCKS", () => {
      const promise = refetchSchedulerData({ dataTimeRange });

      if (filterByScheduleView) refetchWorkOrders({ visibleTimeRange });

      promise.catch((error) => {
        GqlError.handler(error, () => {
          setNotification({
            message: "",
            title: "Unable to load schedule. Please try again.",
            type: "danger",
          });
        });
      });

      return promise;
    });
}
